<template>
  <div :style="quizStyle" id="quiz-section-container">
    <div id="quiz-header-container">
      <h2>Quiz</h2>
    </div>
    <div id="quiz-container">
      <div class="quiz" id="quiz-question-container">
        <div v-if="this.current.cfg === 'select'">
            <div class="select-options-container">
              <div v-for="(option, index) in current.options"
                  :key="index"
                  class="symbol-card"
                  :id="'cardNumber' + String(index)" 
                  :style="isHoveredStyles[index]"
                  @click="checkAnswer(option, index)"
                  @mouseover="hoverEventOver(index)"
                  @mouseleave="hoverEventLeave(index)"
              >
              {{ option.character }}
              </div>
            </div>
            <div id="prompt">{{ this.current.prompt }}
            </div>
        </div>
        <div v-if="this.current.cfg === 'pronounce'">
          <div id="pronounce-character" :style="pronounciationBg">{{ this.current.character }}</div>
          <input v-model=pronounciation id="pronounce-input" @keyup.enter="submitPrnounicaiton(this.current)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: 'Quiz',
props: {
    style: {
      type: Object,
      default: () => ({}),
      Required: false
    },
    qn: {
      type: Object,
      default: () => ({}),
      Required: true
    },
},
data() {
  return {
    current: {},
    index: 0,
    hoverIndex: null,
    hoverbg:  { backgroundColor: "#6495ED", transition: 'background-color 0.3s ease' },
    hoverbgCorrect:  { backgroundColor: "green", transition: 'background-color 0.3s ease' },
    hoverbgIncorrect:  { backgroundColor: "red", transition: 'background-color 0.3s ease' },
    noHover: {backgroundColor: "White", transition: 'background-color 0.3s ease'},
    pronounciationBg: {transition: 'background-color 0.3s ease'},
    isHoveredStyles: [],
    answers: {},
    pronounciation: null,
    quizStyle: null,
    savedQuizStyle: null

  };
},
beforeMount() {
  // This code will be executed before the component is mounted to the DOM
  console.log('Component is about to be mounted!');
  console.log(this.qn);

  // setting and saving the quiz style


  this.savedQuizStyle = JSON.parse(JSON.stringify(this.style));
  console.log(this.savedQuizStyle);
  // /* eslint-disable no-debugger */
  // debugger; // Now this won't be flagged by ESLint
  this.quizStyle = JSON.parse(JSON.stringify(this.style));

  this.current = this.qn[0];

  for (var i = 0; i < this.qn.length; i++) {
    this.isHoveredStyles.push({});
  } 

  console.log(this.current);
},
methods: {
  checkAnswer(option, hoverIndex) {
    if(option.correct) {
      // turn green
      this.isHoveredStyles[hoverIndex] = this.hoverbgCorrect;

      // record the answer was correct
      this.answers[option.character] = {select: true};

    } else {
    // turn red
    this.isHoveredStyles[hoverIndex] = this.hoverbgIncorrect;
    this.answers[option.character] = {select: false};
    }

    this.waitForTransition('#cardNumber' + hoverIndex, 'background-color').then(() => {
        this.index++;
        this.current = this.qn[this.index];
    });


    /* 
      structure: 
      {'青': {prnounce: <val>, select: <val>}}
    */

    // this.$emit('fininshQuiz',)
    return;
  },
  waitForTransition(selector, propertyName) {
      console.log(this.$el);
      return new Promise((resolve) => {
        var element = null;
        if (selector === "#quiz-section-container") {
          element = this.$el;
        } else {
          element = this.$el.querySelector(selector);
        }
        console.log(element);

        const onEnd = (event) => {
          if (event.propertyName === propertyName) {
            element.removeEventListener('transitionend', onEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', onEnd);
      });
    },
  hoverEventOver(hoverIndex) {
    this.hoverIndex = hoverIndex;

    this.isHoveredStyles[hoverIndex] = this.hoverbg;
  },
  hoverEventLeave(hoverIndex) {
    this.isHoveredStyles[hoverIndex] = this.noHover;

    this.hoverIndex = null;
  },
  submitPrnounicaiton(pq){
    this.quizStyle.transition = "background-color 0.3s ease";

    if (pq.answer == this.pronounciation) {
      // change background
      this.quizStyle["background-color"] =  "Green";

      console.log(this.quizStyle)
     

      this.waitForTransition('#quiz-section-container', 'background-color').then(() => {
        setTimeout(() => {
        console.log('Transition has finished!');
        this.quizStyle = JSON.parse(JSON.stringify(this.savedQuizStyle));

        }, 1100);  // 1000ms = 1 second
        


        console.log(this.savedQuizStyle);

        // go to next question after getting the write answer

      });

      console.log("pronouciation")
    } else {
      console.log("wrong ")

      // turn red 
      this.quizStyle.backgroundColor =  "red";

      console.log(this.quizStyle)

      //turn back to white
      this.waitForTransition('#quiz-section-container', 'background-color').then(() => {
        setTimeout(() => {
        console.log('Transition has finished!');
        this.quizStyle = JSON.parse(JSON.stringify(this.savedQuizStyle));

        }, 1);  // 1000ms = 1 second
    });
    }
  }
},
computed: {
}
};
</script>

<style scoped>

#pronounce-input {
  margin-top: 30px;
}

#pronounce-character {
  font-size: 50px;
  margin-top: 20px;
}

#prompt {
  margin-top:30px;
}

.symbol-card {
  width: 90px;           /* Set the desired width */
  height: 100px;          /* Set the desired height */
  border: 1px solid #ccc; /* Optional: border styling */
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 9px;
}
/* 
.symbol-card:hover {
      background-color: #6495ED;
    } */

.select-options-container {
  display: flex;
  justify-content: space-evenly;
  margin-top: 50px;
}

.quiz {
  text-align: center;
}

#quiz-section-container {
  border: 2px solid grey;
  margin-top: 40px;
  padding: 30px 0px 30px 0px; 
  border-radius: 9px;
}

#quiz-header-container {

  display: flex;
  justify-content: center;
}
</style>
